module.exports = __webpack_public_path__ + "media/promo/courses/images/ic-2-ad22693a702d9c1ad719b7b68acdcc97.png";